import React, { Component } from 'react';
import Select from 'react-select'

const languages = [
  //SNS対応国
    { value: 'en', label: 'English' }, //英語
    { value: 'ja', label: '日本語' }, //日本語
    { value: 'es', label: 'Español' },//スペイン語
    { value: 'ru', label: 'русский' },//ロシア語 
    { value: 'fr', label: 'français' },//フランス語
    { value: 'de', label: 'Deutsch' },//ドイツ語
    { value: 'it', label: 'italiano' },//イタリア語
    { value: 'zh', label: '中文' },//中国語
    { value: 'ko', label: '한국어' },//韓国語
    { value: 'ar', label: 'عربى' },//アラビア語
    { value: 'hi', label: 'हिन्दी' },//ヒンディー語
    { value: 'id' ,label: 'bahasa Indonesia'},//インドネシア語
    { value: 'pt' ,label: 'Português'},//ポルトガル語
    //SNS非対応言語 Linkは英語
    { value: 'fi', label: 'Suomalainen' },//フィンランド語
    { value: 'tr', label: 'İspanyol' },//トルコ語
    { value: 'ms', label: 'Bahasa Melayu' },//マレー語
    { value: 'ta', label: 'தமிழ்' },//タミル語
  ]

const youtubeLink = {
  en : "xVLCOCx0-Mc",
  ja : "MirYJLqQXX0",
  es : "VNQJQXy4G1E",
  ru : "_a81VEDxG0w",
  fr : "YhI6_TxRemA",
  de : "dX-1AbnEsaU",
  it : "YheontOEMhU",
  zh : "8JwgvqgcGHw",
  ko : "Wk1PwVW2plU",
  ar : "PQ4KY3fAKYA",
  hi : "YGZS8tGtxec",
  id : "LCA4Ay8qIhg",
  pt : "wYJTgFJOZ3Y",
}
  
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      ':active':{backgroundColor:'silver'}
    }),
    singleValue: (provided, state) => {
  
      const opacity = 0;
      const transition = 'opacity 1000ms';
  
      //return { ...provided, opacity, transition };
      return { ...provided };
    }
  }

  export default class LangSelect extends Component {
    state = {
        selectedOption: languages[0],
      };

      constructor(props) {
        super(props);
        this.state = {
          openMenu: false,
          visibilityClass: '',
        };
      }
      toggleMenu = value => {
        this.setState({ openMenu: value });
      };
      
      langChange = (selectedOption) => {
        this.setState({ selectedOption }, () =>{
          //console.log(`Option selected:`, this.state.selectedOption)
          let selectedLang;
          let locaLangage = localStorage.getItem('Langage');

          //SELECTで言語を選択しているか
          if(!selectedOption){
            const languageMap = languages.map(language => language.value);
            let languageCheck = languageMap.includes(locaLangage);
            if(!locaLangage || !languageCheck){
              selectedLang = languages[0].value;
            }else{
              selectedLang = locaLangage;
            }
          }else{
            selectedLang = selectedOption.value;
          }

          //ローカルストレージ保存
          localStorage.setItem('Langage', selectedLang);

          //選択言語ローカルストレージ送信
          if(selectedLang){
            //webサイト配列
            const urls = [
              'http://c-dice.info/share_local_storage?'+ selectedLang,
              'http://c-coin.info/share_local_storage?'+ selectedLang,
            ];
            let iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            urls.forEach(url => {
              iframe.src = url;
              document.body.appendChild(iframe);
            });
          }

          // 文字言語表示切替
          const elm = document.getElementsByClassName("langCng");
          for (let i = 0; i < elm.length; i++) {
            // --- 選択された言語と一致は表示、その他は非表示 -------
            if(elm[i].getAttribute("lang") == selectedLang){
              elm[i].style.display = 'block';
            }
            else{
              elm[i].style.display = 'none';
            }
          }
        });
    }

    handleScroll = () => {
        const { visibilityClass } = this.state;
        if (window.pageYOffset > 300) {
          if (visibilityClass !== 'navbar-shrink') {
            this.setState({ visibilityClass: 'navbar-shrink' });
          }
        } else {
          if (visibilityClass === 'navbar-shrink') {
            this.setState({ visibilityClass: '' });
          }
        }
      };

      componentDidMount() {
        this.langChange();
        window.addEventListener('scroll', this.handleScroll);
      }
      componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
      }

      render() {
        const { selectedOption } = this.state;
        const { openMenu, visibilityClass } = this.state;
    return(
        <Select
        placeholder="Language"
        isSearchable={ false }
        isOptionDisabled={(option) => option.disabled}
        defaultValue={languages[0].value}
        options={languages}
        onChange={this.langChange}
        value={selectedOption}
        className="langSelect"
        styles={customStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'gainsboro',
            primary: 'black',
          },
        })}
        />
    );
      }
  }